import sticky from "jquery-sticky"
import AOS from 'aos'
import rotate from 'jquery.auto-text-rotating'
import count from 'jquery-countto'
import appear from 'jquery.appear'
var $ = require('jquery')

$(function() {
    var $hamburger = $(".head__hamburger");
      $hamburger.on("click", function(e) {
        $hamburger.toggleClass("head__hamburger--isActive");
        $('.head__mobilemenu').addClass('mmenu');
        $(".head__mobilemenu").toggle();
      });

      $(".headwrap").sticky({
		zIndex: 10000
	   })

    AOS.init({
		easing: 'ease-out',
		offset: 200,
	})

    var settings = {
        delay: 2000,
        separator: ',',
    };
    $('.rotate').atrotating(settings);

    $('.stats').appear(function() {
      $('.timer').countTo();
    });

    $(window).bind("load resize scroll",function(e) {
        var y = $(window).scrollTop();
        $(".wrap").filter(function() {
            return $(this).offset().top < (y + $(window).height()) &&
                   $(this).offset().top + $(this).height() > y;
        }).css('background-position', '0px ' + parseInt(-y / 1.5) + 'px');
    });
    

    $(document).ready(function() {
        var offsetSize = $(".headwrap").innerHeight();
        if ($(location.hash).length)
            $("html, body").animate({
                scrollTop: $(location.hash).offset().top - offsetSize
            }, 500);
    });

})
